export default {
  namespaced: true,
  state: {
    translationActivatedAccessPointUUIDs: new Set()
  },
  mutations: {
    activateTranslationForAccessPoint(state, accessPointUUID) {
      state.translationActivatedAccessPointUUIDs.add(accessPointUUID)
    },
    deactivateTranslationForAccessPoint(state, accessPointUUID) {
      state.translationActivatedAccessPointUUIDs.delete(accessPointUUID)
    },
    deactivateTranslationForAllAccessPoints(state) {
      state.translationActivatedAccessPointUUIDs.clear()
    }
  },
  getters: {
    isTranslationActivatedForAccessPoint: (state) => (accessPointUUID) => {
      console.log('set has ', accessPointUUID, state.translationActivatedAccessPointUUIDs.has(accessPointUUID))
      return state.translationActivatedAccessPointUUIDs.has(accessPointUUID)
    }
  }
}